import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import * as moment from "moment";
import { HgService } from "src/app/services/http/hg.service";
import { ModalMsgService } from "src/app/services/modal-msg.service";
import { UtilMasks } from "src/app/utils/util-masks";

@Component({
  selector: "app-form-hg-laudo",
  templateUrl: "./form-hg-laudo.component.html",
  styleUrls: ["./form-hg-laudo.component.scss"],
})
export class FormHgLaudoComponent implements OnInit, OnDestroy {
  constructor(
    private _hgService: HgService,
    private _msgService: ModalMsgService
  ) {}

  @Input() placa: string = "";
  @Input() tokenLaudo: string = "";
  @Output() formHgValidoEmit = new EventEmitter<any>();

  masks = {
    placa: { mask: UtilMasks.placa, guide: false },
    renavam: { mask: UtilMasks.cnpj, guide: false },
  };
  dadosSalvosUnion: any = null;
  hgFinalizado: boolean = false;
  existeErroHg: boolean = false;
  msgErroHg: string = null;
  idAvaliacao: number = 0;
  isDestroy: boolean = false;
  isAutenticadoHg: boolean = false;
  isVeiculoEncontradoHg: boolean = false;
  isVeiculoEncontradoUnion: boolean = false;
  tokenHg: string = null;
  refreshTokenHg: string = null;
  entityHgId: string = null;
  instanceHgId: string = null;
  userHgId: string = null;
  modeloInicial = { id: "", name: "" };
  marcaInicial = { id: "", name: "" };
  versaoInicial = { id: "", name: "" };
  listaCores: any[] = [];
  listaCombustiveis: any[] = [];
  listaKinds: any[] = [];
  listaOrigens: any[] = [];
  listaTransmissoes: any[] = [];
  listaPortas: any[] = [];
  listaBody: any[] = [];
  listaClassificacoesAvaliacao: any[] = [];
  listaMarcas: any[] = [];
  listaModelos: any[] = [];
  listaVersoes: any[] = [];
  listaOpcionais: any[] = [];
  listaOpcionaisSelecionados: any[] = [];
  listaItensAvaliacao: any[] = [];
  listaItensAvaliacaoSelecionados: any[] = [];
  listaItensAvaliacaoSaida: any[] = [];
  listaItensAvaliacaoSalvosUnion: any[] = [];
  listaItensOpcionaisSalvosUnion: any[] = [];

  form = new FormGroup({
    anoFabricacao: new FormControl("", Validators.required),
    bodyTypeId: new FormControl("", Validators.required),
    corId: new FormControl("", Validators.required),
    portas: new FormControl("", Validators.required),
    combustivelId: new FormControl("", Validators.required),
    kindId: new FormControl("", Validators.required),
    placa: new FormControl("", Validators.required),
    marcaId: new FormControl("", Validators.required),
    modeloId: new FormControl("", Validators.required),
    origemId: new FormControl("", Validators.required),
    cilindradas: new FormControl(""),
    transmissaoId: new FormControl("", Validators.required),
    versaoId: new FormControl("", Validators.required),
    chassi: new FormControl("", Validators.required),
    anoModelo: new FormControl("", Validators.required),
    renavam: new FormControl("", Validators.required),
    motor: new FormControl("", Validators.required),
    quilometragem: new FormControl("", Validators.required),
    listaItensOpcionais: new FormControl([]),
    listaItensAvaliacao: new FormControl([], Validators.required),
    obsAvaliacaoHg: new FormControl("", Validators.required),
  });

  async ngOnInit(): Promise<void> {
    this.isDestroy = false;
    await this.dadosDeAvaliacaoHg();
    this.form.markAllAsTouched();
  }

  async dadosDeAvaliacaoHg(): Promise<void> {
    try {
      this.dadosSalvosUnion = await this._hgService.getDadosAvaliacaoHgUnion(
        this.tokenLaudo
      );
      await this.serviceStorage(this.dadosSalvosUnion);
      await this.montarListasHg();
      await this.tratarVeiculoEncontradoUnion(this.dadosSalvosUnion);
    } catch (error) {
      this._msgService.openDialog(
        `Não foi possível localizar o seu cadastro de integração do laudo!`,
        `Realize a autenticação novamente.`,
        "danger"
      );
    }
  }

  async serviceStorage(dadosSalvosUnion) {
    if (localStorage.getItem("hgDadosStorage") == null) {
      await this.authHg(
        dadosSalvosUnion?.veiculo?.emailHg,
        dadosSalvosUnion?.veiculo?.senhaHg
      );
    } else {
      let hgDadosStorage = JSON.parse(localStorage.getItem("hgDadosStorage"));

      let inicio = moment(hgDadosStorage["createIn"]);
      let fim = moment();
      var diff = moment(fim, "DD HH").diff(moment(inicio, "DD HH"));
      var horas = moment.duration(diff).asHours();

      if (horas < 24) {
        this.isAutenticadoHg = true;
        this.tokenHg = hgDadosStorage["tokenHg"];
        this.refreshTokenHg = hgDadosStorage["refreshTokenHg"];
        this.entityHgId = hgDadosStorage["entityHgId"];
        this.instanceHgId = hgDadosStorage["instanceHgId"];
        this.userHgId = hgDadosStorage["userHgId"];
      } else
        await this.authHg(
          dadosSalvosUnion?.veiculo?.emailHg,
          dadosSalvosUnion?.veiculo?.senhaHg
        );
    }
  }

  async authHg(emailHg, senhaHg) {
    await this._hgService
      .autenticarHg(emailHg, senhaHg)
      .then((dadosAuth) => {
        this.tokenHg = dadosAuth?.auth?.token;
        this.refreshTokenHg = dadosAuth?.auth?.refreshToken;
        this.entityHgId = dadosAuth?.entity?.id;
        this.instanceHgId = dadosAuth?.instance?.id;
        this.userHgId = dadosAuth?.user?.id;
        this.isAutenticadoHg = true;
        this.setStorageTokenHg();
      })
      .catch((e) => {
        this._msgService.openDialog(
          `Não foi possível localizar o seu cadastro de integração do laudo!`,
          `Realize a autenticação novamente.`,
          "danger"
        );
      });
  }

  async reAuthHg(emailHg, senhaHg) {
    await this._hgService
      .autenticarHg(emailHg, senhaHg)
      .then((dadosAuth) => {
        this.tokenHg = dadosAuth?.auth?.token;
        this.refreshTokenHg = dadosAuth?.auth?.refreshToken;
        this.entityHgId = dadosAuth?.entity?.id;
        this.instanceHgId = dadosAuth?.instance?.id;
        this.userHgId = dadosAuth?.user?.id;
        this.isAutenticadoHg = true;
        this.setStorageTokenHg();
        this._hgService.salvarReAuth(emailHg, senhaHg, this.tokenLaudo);
        this.dadosDeAvaliacaoHg();
      })
      .catch((e) => {
        this._msgService.openDialog(
          `Não foi possível localizar o seu cadastro de integração do laudo!`,
          `Realize a autenticação novamente.`,
          "danger"
        );
      });
  }

  setStorageTokenHg() {
    localStorage.removeItem("hgDadosStorage");
    var now = moment();

    let hgDadosStorage = {
      tokenHg: this.tokenHg,
      refreshTokenHg: this.refreshTokenHg,
      createIn: now,
      entityHgId: this.entityHgId,
      instanceHgId: this.instanceHgId,
      userHgId: this.userHgId,
    };

    return;

    //localStorage.setItem("hgDadosStorage", JSON.stringify(hgDadosStorage));
  }

  async montarListasHg() {
    await this._hgService
      .getListaItensAvaliacaoHg(this.tokenHg)
      .then((listaItensAvaliacao) => {
        this.listaItensAvaliacao = listaItensAvaliacao;
        this.sortListas(this.listaItensAvaliacao);
      });

    await this._hgService
      .getListaOpcionaisHg(this.tokenHg)
      .then((listaOpcionais) => {
        this.listaOpcionais = listaOpcionais;
        this.sortListas(this.listaOpcionais);
      });

    await this._hgService.montarListasHg(this.tokenHg).then((dadosIniciais) => {
      this.listaCores = dadosIniciais["colors"];
      this.listaCombustiveis = dadosIniciais["fuelTypes"];
      this.listaKinds = dadosIniciais["kinds"];
      this.listaOrigens = dadosIniciais["origin"];
      this.listaTransmissoes = dadosIniciais["transmissionTypes"];
      this.listaPortas = dadosIniciais["doors"];
      this.listaBody = dadosIniciais["bodyTypes"];
      this.listaClassificacoesAvaliacao = dadosIniciais["itemsRatings"];
    });
  }

  opcionaisSelecionados(opcionais: Array<any>) {
    this.sortListas(this.listaOpcionais);
    this.sortListas(this.listaOpcionaisSelecionados);
    this.form.controls.listaItensOpcionais.patchValue(
      this.listaOpcionaisSelecionados
    );
  }

  opcionaisRemovidos(opcionais: Array<any>) {
    this.sortListas(this.listaOpcionais);
    this.sortListas(this.listaOpcionaisSelecionados);
    this.form.controls.listaItensOpcionais.patchValue(
      this.listaOpcionaisSelecionados
    );
  }

  itensAvaliadosSelecionados(itens: Array<any>) {
    this.sortListas(this.listaItensAvaliacao);
    this.sortListas(this.listaItensAvaliacaoSelecionados);
  }

  itensAvaliadosRemovidos(itens: Array<any>) {
    this.sortListas(this.listaItensAvaliacao);
    this.sortListas(this.listaItensAvaliacaoSelecionados);
    if (this.listaItensAvaliacaoSelecionados.length == 0) {
      this.form.controls.listaItensAvaliacao.patchValue([]);
    }
    this.listaItensAvaliacaoSaida = this.listaItensAvaliacaoSaida.filter(
      (i) => i.itemId != itens[0].id
    );
    this.form.controls.listaItensAvaliacao.patchValue(
      this.listaItensAvaliacaoSaida
    );
  }

  itemAvaliadoCheck(item, classificacao) {
    if (this.listaItensAvaliacaoSaida.length > 0)
      this.listaItensAvaliacaoSaida = this.listaItensAvaliacaoSaida.filter(
        (i) => i.itemId != item.id
      );

    this.listaItensAvaliacaoSaida.push({
      itemId: item.id,
      classificacaoId: classificacao.id,
      observacao: "",
    });

    this.form.controls.listaItensAvaliacao.patchValue(
      this.listaItensAvaliacaoSaida
    );

    (<boolean | null>document.getElementById("obsItem" + item?.name).hidden) =
      false;
  }

  itemAvaliadoObservacaoKeyUp(item, observacao) {
    this.listaItensAvaliacaoSaida.forEach((i) => {
      if (i?.itemId == item?.id) {
        i["observacao"] = observacao;
      }
    });
    this.form.controls.listaItensAvaliacao.patchValue(
      this.listaItensAvaliacaoSaida
    );
  }

  sortListas(lista) {
    if (lista == null || lista.length == 0) return;
    lista.sort(function (a, b) {
      return a.name.localeCompare(b.name);
    });
  }

  async tratarVeiculoEncontradoUnion(dadosSalvos) {
    this.isVeiculoEncontradoHg = true;
    this.isVeiculoEncontradoUnion = true;

    this.hgFinalizado = dadosSalvos?.veiculo?.finalizado || false;
    if (this.hgFinalizado) {
      this.existeErroHg = false;
      this.idAvaliacao = dadosSalvos?.veiculo?.avaliacaoId || 0;
      this.form.disable();
    } else {
      this.existeErroHg = dadosSalvos?.erroHg || false;
      if (this.existeErroHg) this.msgErroHg = dadosSalvos?.msgErroHg || null;
    }

    if (dadosSalvos?.veiculo?.marcaId != null) {
      this.marcaInicial.id = dadosSalvos?.veiculo?.marcaId;
    }

    if (dadosSalvos?.veiculo?.modeloId != null) {
      this.modeloInicial.id = dadosSalvos?.veiculo?.modeloId;
    }

    if (dadosSalvos?.veiculo?.versaoId != null) {
      this.versaoInicial.id = dadosSalvos?.veiculo?.versaoId;
    }

    if (dadosSalvos?.veiculo?.anoFabricacao != null)
      this.form.controls.anoFabricacao.patchValue(
        dadosSalvos?.veiculo?.anoFabricacao
      );
    if (
      dadosSalvos?.veiculo?.carroceriaId != null &&
      dadosSalvos?.veiculo?.carroceriaId != 0
    )
      this.form.controls.bodyTypeId.patchValue(
        dadosSalvos?.veiculo?.carroceriaId
      );
    if (dadosSalvos?.veiculo?.corId != null && dadosSalvos?.veiculo?.corId != 0)
      this.form.controls.corId.patchValue(dadosSalvos?.veiculo?.corId);
    if (dadosSalvos?.veiculo?.portas != null)
      this.form.controls.portas.patchValue(dadosSalvos?.veiculo?.portas);
    if (
      dadosSalvos?.veiculo?.combustivelId != null &&
      dadosSalvos?.veiculo?.combustivelId != 0
    )
      this.form.controls.combustivelId.patchValue(
        dadosSalvos?.veiculo?.combustivelId
      );
    if (
      dadosSalvos?.veiculo?.tipoId != null &&
      dadosSalvos?.veiculo?.tipoId != 0
    )
      this.form.controls.kindId.patchValue(dadosSalvos?.veiculo?.tipoId);
    if (dadosSalvos?.veiculo?.placa != null)
      this.form.controls.placa.patchValue(dadosSalvos?.veiculo?.placa);
    if (
      dadosSalvos?.veiculo?.origemId != null &&
      dadosSalvos?.veiculo?.origemId != 0
    )
      this.form.controls.origemId.patchValue(dadosSalvos?.veiculo?.origemId);
    if (dadosSalvos?.veiculo?.cilindrada != null)
      this.form.controls.cilindradas.patchValue(
        dadosSalvos?.veiculo?.cilindrada
      );
    if (
      dadosSalvos?.veiculo?.transmissao != null &&
      dadosSalvos?.veiculo?.transmissao != 0
    )
      this.form.controls.transmissaoId.patchValue(
        dadosSalvos?.veiculo.transmissao
      );
    if (dadosSalvos?.veiculo?.chassi != null)
      this.form.controls.chassi.patchValue(dadosSalvos?.veiculo?.chassi);
    if (dadosSalvos?.veiculo?.anoModelo != null)
      this.form.controls.anoModelo.patchValue(dadosSalvos?.veiculo?.anoModelo);
    if (dadosSalvos?.veiculo?.renavam != null)
      this.form.controls.renavam.patchValue(dadosSalvos?.veiculo?.renavam);
    if (dadosSalvos?.veiculo?.motor != null)
      this.form.controls.motor.patchValue(dadosSalvos?.veiculo?.motor);
    if (dadosSalvos?.veiculo?.quilometragem != null)
      this.form.controls.quilometragem.patchValue(
        dadosSalvos?.veiculo?.quilometragem
      );

    if (dadosSalvos?.veiculo?.marcaId != null)
      this.form.controls.marcaId.patchValue(dadosSalvos?.veiculo?.marcaId);
    if (dadosSalvos?.veiculo?.modeloId != null)
      this.form.controls.modeloId.patchValue(dadosSalvos?.veiculo?.modeloId);
    if (dadosSalvos?.veiculo?.versaoId != null)
      this.form.controls.versaoId.patchValue(dadosSalvos?.veiculo?.versaoId);

    if (dadosSalvos?.listaItensAvaliacao != null) {
      await dadosSalvos?.listaItensAvaliacao.forEach((item) => {
        let dado = this.listaItensAvaliacao.filter((i) => i.id == item.itemId);
        let classificacao = this.listaClassificacoesAvaliacao.filter(
          (i) => i.id == item.classificacaoId
        );
        if (dado[0] == null || classificacao[0] == null) return;
        dado[0]["observacao"] = item?.observacao;
        this.listaItensAvaliacaoSelecionados.push(dado[0]);
        this.listaItensAvaliacaoSaida.push({
          itemId: dado[0]?.id,
          classificacaoId: classificacao[0]?.id,
          name: dado[0]?.name,
          observacao: dado[0]?.observacao,
        });
        this.listaItensAvaliacao = this.listaItensAvaliacao.filter(
          (i) => i.id != item.itemId
        );
        this.form.controls.listaItensAvaliacao.patchValue(
          this.listaItensAvaliacaoSaida
        );
      });
    }

    if (dadosSalvos?.listaOpcionais != null) {
      await dadosSalvos?.listaOpcionais.forEach((item) => {
        let dado = this.listaOpcionais.filter((i) => i.id == item.itemId);
        this.listaOpcionaisSelecionados.push(dado[0]);
        this.listaOpcionais = this.listaOpcionais.filter(
          (i) => i.id != item.itemId
        );
        this.form.controls.listaItensOpcionais.patchValue(
          this.listaOpcionaisSelecionados
        );
      });
    }

    if (dadosSalvos?.veiculo?.observacao)
      this.form.controls.obsAvaliacaoHg.patchValue(
        dadosSalvos?.veiculo?.observacao
      );

    setTimeout(() => {
      this.listaItensAvaliacaoSaida.forEach((item) => {
        (<HTMLInputElement | null>(
          document.getElementById(item?.name + item?.classificacaoId)
        ))?.setAttribute("checked", "true");
        (<boolean | null>(
          document.getElementById("obsItem" + item?.name).hidden
        )) = false;
      });
    }, 3000);

    await this.getListaMarcasHg(true, this.isVeiculoEncontradoUnion);
  }

  async getListaMarcasHg(
    veiculoEncontradoHg: boolean,
    veiculoEncontradoUnion: boolean
  ) {
    this.isVeiculoEncontradoHg = veiculoEncontradoHg;
    this.isVeiculoEncontradoUnion = veiculoEncontradoUnion;

    if (!veiculoEncontradoHg && !veiculoEncontradoUnion)
      this.form.controls.marcaId.patchValue("");

    this.listaMarcas = null;
    this.listaModelos = null;
    this.listaVersoes = null;

    await this._hgService
      .getListaMarcasHg(this.tokenHg)
      .then(async (marcas) => {
        this.listaMarcas = marcas;
        if (veiculoEncontradoHg) {
          this.marcaInicial = marcas.find(
            (marca) => marca?.id == this.form.value.marcaId
          );
        }

        if (veiculoEncontradoUnion) {
          this.marcaInicial = marcas.find(
            (marca) => marca?.id == this.marcaInicial?.id
          );
        }
      })
      .finally(async () => {
        if (this.marcaInicial?.id)
          this.form.controls.marcaId.patchValue(this.marcaInicial?.id || "");

        await this.getListaModelosHg(
          this.marcaInicial?.id,
          veiculoEncontradoHg,
          veiculoEncontradoUnion
        );
      });
  }

  async getListaModelosHg(
    marcaId: string,
    veiculoEncontradoHg: boolean,
    veiculoEncontradoUnion: boolean
  ) {
    if (marcaId == null || marcaId == "") return;

    this.form.controls.marcaId.patchValue(marcaId);

    this.isVeiculoEncontradoHg = veiculoEncontradoHg;
    this.isVeiculoEncontradoUnion = veiculoEncontradoUnion;

    if (!veiculoEncontradoHg && !veiculoEncontradoUnion) {
      this.form.controls.modeloId.patchValue("");
      this.form.controls.versaoId.patchValue("");
    }
    this.listaModelos = null;
    this.listaVersoes = null;

    await this._hgService
      .getListaModelosHg(marcaId, this.tokenHg)
      .then(async (modelos) => {
        this.listaModelos = modelos;
        if (veiculoEncontradoHg) {
          this.modeloInicial = modelos.find(
            (modelo) => modelo?.id == this.form.value.modeloId
          );
        }

        if (veiculoEncontradoUnion) {
          this.modeloInicial = modelos.find(
            (modelo) => modelo?.id == this.modeloInicial?.id
          );
        }
      })
      .finally(async () => {
        if (this.modeloInicial?.id)
          this.form.controls.modeloId.patchValue(this.modeloInicial?.id || "");

        await this.getListaVersoesHg(
          this.modeloInicial?.id,
          veiculoEncontradoHg,
          veiculoEncontradoUnion
        );
      });
  }

  async getListaVersoesHg(
    modeloId: string,
    veiculoEncontradoHg: boolean,
    veiculoEncontradoUnion: boolean
  ) {
    if (modeloId == null || modeloId == "") return;

    this.form.controls.modeloId.patchValue(modeloId);

    this.isVeiculoEncontradoHg = veiculoEncontradoHg;
    this.isVeiculoEncontradoUnion = veiculoEncontradoUnion;

    if (!veiculoEncontradoHg && !veiculoEncontradoUnion)
      this.form.controls.versaoId.patchValue("");

    this.listaVersoes = null;

    await this._hgService
      .getListaVersoesHg(modeloId, this.tokenHg)
      .then(async (versoes) => {
        this.listaVersoes = versoes;

        if (veiculoEncontradoHg) {
          this.versaoInicial = versoes.find(
            (versao) => versao?.id == this.form.value.versaoId
          );
        }

        if (veiculoEncontradoUnion) {
          this.versaoInicial = versoes.find(
            (versao) => versao?.id == this.versaoInicial?.id
          );
        }
      })
      .finally(() => {
        if (this.versaoInicial?.id)
          this.form.controls.versaoId.patchValue(this.versaoInicial?.id || "");
      });
  }

  setVersaoHg(versaoId) {
    if (versaoId == null || versaoId == "") return;

    this.form.controls.versaoId.patchValue(versaoId);
  }

  async salvarAvaliacaoHg() {
    if (!this.hgFinalizado) {
      await this.emitirValidadorFormHg(
        this.form.valid,
        this.isDestroy,
        this.form.value
      );
    }
    this.isDestroy = false;
  }

  async emitirValidadorFormHg(
    isFormHgValid: boolean,
    isDestroy: boolean,
    formHg: any
  ) {
    if (!this.hgFinalizado) {
      this.formHgValidoEmit.emit({
        isFormHgValid: isFormHgValid,
        isDestroy: isDestroy,
        formHg: formHg,
        entityHgId: this.entityHgId,
        instanceHgId: this.instanceHgId,
        userHgId: this.userHgId,
      });
    }
  }

  showErrorHg() {
    this._msgService.openDialog(
      `Falha no envio da avaliação ao HG!`,
      `Motivo: ${this.msgErroHg}`,
      "danger"
    );
  }

  async ngOnDestroy() {
    this.isDestroy = true;
    if (!this.hgFinalizado) {
      // await this.salvarAvaliacaoHg();
    }
  }
}
